/** @format */

import React from 'react';
import CustomTextButtom from '../../Buttons/CustomTextButton';

interface CardBoxActionInterface {
    classes: any;
    actionCallback: () => void;
}

const CardBoxAction = (props: CardBoxActionInterface): React.ReactElement => {
    return (
        <div className={props.classes.cardBoxAction}>
            <CustomTextButtom
                fullWidth
                callback={props.actionCallback}
                callbackParam={{}}
                color="primary"
                label="general:common.make_edit"
                size={'lg'}
            />
        </div>
    );
};

export default CardBoxAction;
